export default {
	personalCenter: {
		vip_member: 'VIP会员',
		vip: {
			level_label: 'VIP{level} 等级', next_level: '下一等级：VIP{level}',
			points_summary: '当前累计 {current} 积分，距离VIP{level}还需 {remaining} 积分',
			level_rewards: '等级奖励', reward_title: 'VIP{level} 奖励', exclusive_rewards: '专属奖励', promotion_reward: 'VIP{level} 晋升奖励',
			previous_level: '上一个等级', next_level_button: '下一个等级',
			dragon_key: '龙魂秘钥 ×{count}', battle_shard: '战纹碎片 ×{count}', forge_crystal: '锻造灵晶 ×{count}',
			unlocked: '已达到 VIP{level}，可立即领取。', locked: '尚未达到 VIP{level}。',
			claim: '领取', claiming: '领取中...', claimed: '已领取', claim_success: 'VIP{level} 奖励已领取', claim_failed: '领取失败，请稍后重试',
			points_label: '积分', go_redeem: '前往兑换',
			experience_summary: '当前累计 {current} 经验；距离VIP{level}还需 {remaining} 经验',
			max_level: '恭喜，您已满级', current_experience: '当前经验值 {current}'
		},
		title: '个人中心', my_exchange: '我的兑换', my_points: '我的积分', lottery_records: '抽奖记录', recharge_records: '储值记录',
		redeem_gift: '兑换礼包', redeem_description: '输入兑换码后，奖励将发放到当前选择的角色。', redeem_code: '兑换码', redeem_code_placeholder: '请输入兑换码', redeeming: '兑换中...', redeem_now: '立即兑换', rebate_coupon: '{percent}%返利券',
		points_details: '积分明细', exchange_time: '兑换时间', reward_content: '奖励内容', status: '状态', time: '时间', type: '类型', points_change: '积分变动', balance: '余额', lottery_time: '抽奖时间', reward: '奖励',
		order_id: '订单号', payment_channel: '支付渠道', amount: '金额', server: '服务器', role: '角色', payment_time: '支付时间', copy: '复制',
		loading: '加载中...', no_records: '没有匹配的记录', no_content: '当前还没有可展示内容。', previous: '上一页', next: '下一页', page_info: '第 {current} / {total} 页',
		source_recharge_reward: '充值奖励', source_official_activity: '官网活动', source_item_exchange: '道具兑换',
		exchange_success: '兑换成功', exchange_failed: '兑换失败', enter_redeem_code: '请输入兑换码', exchange_retry: '兑换失败，请稍后重试',
		copy_success: '复制成功', copy_failed: '复制失败', lottery_load_failed: '抽奖记录加载失败', lottery_load_retry: '抽奖记录加载失败，请稍后重试',
		recharge_load_failed: '储值记录加载失败', recharge_load_retry: '储值记录加载失败，请稍后重试', points_load_failed: '积分记录加载失败', points_load_retry: '积分记录加载失败，请稍后重试',
		exchange_records_load_failed: '兑换记录加载失败', exchange_records_load_retry: '兑换记录加载失败，请稍后重试'
	},
	member_popup: {
		title: '恭喜！会员积分已增加',
		message: '本次充值获得 {points} 点会员积分，距离晋升「VIP{nextLevel}」还需 {remaining} 点。',
		progress: '累计充值积分 {current} / {target}',
		next: '距离晋升VIP{nextLevel}还需 {remaining} 积分',
		suppress: '7天内不再提示',
		later: '稍后再说',
		rewards: '前往领取奖励',
		close: '关闭会员积分提示'
	},
	member_level: {
		title: '会员等级',
		points_progress: '累计充值积分',
		next_level: '距离晋升VIP{level}还需',
		points_unit: '积分',
		view_rewards: '查看等级奖励'
	},
	login_button_text: '登录',
	logining_button_text: '登录中',
	account_input_text: '请输入邮箱地址',
	password_input_text: '请输入密码',
	other_login_methods_text: '其他登录方式',
	top_up_center_text: '充值中心',
	benefit_text: '福利',
	sign_in_text: '登录',
	log_out_text: '登出',
	service_terms_text: '服务条款',
	privacy_policy_text: '隐私政策',
	official_apk_download_text: '官方apk版本下载',
	official_facebook_text: '官方粉丝页',
	recharge_instructions_text: '充值说明',	rebate_countdown_title: '限时返利开启中',
	rebate_countdown_label: '倒计时',
	rebate_countdown_days: '天',
	rebate_countdown_hours: '时',
	rebate_countdown_minutes: '分',
	rebate_countdown_seconds: '秒',	log_in_game_account_text: '请登录游戏账号',
	sign_in_lowercase_text: '登录',
	instructions_text: '说明',
	confirm_text: '确认',
	switch_character_text: '切换角色',
	copy_successful_text: '复制成功',
	claimed_text: '已领取',
	claim_success_text: '领取成功',
	claim_text: '领取',
	claim_unmet_text: '不满足',
	contact_customer_service_text: '联系客服',
	home_page_text: '主页',
	payment_successful_text: '付款成功',
	purchase_confirm_text: '确认购买',
	payment_channels_text: '付款渠道',
	payment_button_text: '购买',
	original_price_text: '原价',
	discounts_text: '折扣',
	earn_points_text: '获得积分',
	rebates_text: '返利',
	amount_text: '价格',
	insufficient_points_text: '积分不足',
	insufficient_lottery_count_text: '抽奖次数不足',
	network_error_retry_text: '网络错误，请稍后重试',
	score_lottery_text: '积分抽奖',
	score_lottery_entrance_error: '请求积分抽奖入口接口出错:',
	lottery_current_points_label: '当前积分:',
	lottery_points_recharge_tip: '积分可通过充值获得',
	lottery_spin_label: '转盘抽奖',
	lottery_rule_button: '规则详情',
	lottery_rule_popup_title: '活动规则',
	lottery_record_button: '获奖记录',
	lottery_record_title: '获奖记录',
	lottery_record_empty: '暂无记录',
	lottery_record_time: '时间',
	lottery_record_prize: '奖品内容',
	lottery_daily_limit: '今日已达上限',
	lottery_remaining_count: '剩余次数 {count}',
	lottery_draw_cost: '{cost}积分/次',
	lottery_init_data_error: '请求积分抽奖数据接口出错:',
	daily_rewards_text: '每日奖励',
	points_text: '积分商城',
	winning_award_text: "恭喜获奖",
	points_limit_tips_text: "该奖励已领取完毕，请等待冷却时间结束后再次兑换～",
	receive_reward_tips_text: "奖励已发送至您角色的邮箱，请登录游戏角色领取！",
	hot_title_text: "充值有礼",
	other_title_text: "enjoy充值",
	limit_title_text: "首充返利",
	limit_text: "限购",
	ingame_title_text: "点卡",
	sell_out_text: "售罄",
	copy_fail_text: '复制失败',
	payment_type_text: '支付渠道',
	order_id_text: '订单号',
	payment_time_text: '支付时间',
	copy_text: '复制',
	amount_text: '金额',
	game_server_text: '服务器',
	game_role_text: '角色',
	orders_records_text: '充值记录',
	no_data_text: '暂无数据',
	orders_tips_text: '根据系统设定，充值记录查询范围限定为最近30天内的订单信息',
	pointsdescribetext: '',
	pointsbalancetext: '',
	points_period_daily: '本日',
	points_period_week: '本周',
	points_period_month: '本月',
	points_period_lifetime: '终身',
	points_tag_mustBuy: '必买',
	points_tag_selected: '精选',
	points_tag_discount: '优惠',
	points_tag_perk: '福利',
	coupon: {
		discount_label: '返利券',
		title_html: '使用返利券购买后可额外获得返利。',
		expired_text: '已失效',
		used_text: '已使用',
		countdown_prefix: '倒计时',
		activity_button_text: '返利券抽奖'
	},
	pagination: {
		previous: "上一页",
		next: "下一页",
		page_info: "第 {current} 页 / 共 {total} 页"
	},
	support_my_questions: '我的问题',
	support_submit_issue: '提交问题',
	support_records_title: '我的问题记录',
	support_records_desc: '查看处理进度，也可以继续补充资料。',
	support_refresh: '刷新',
	support_tabs_label: '客服选项',
	support_load_more: '加载更多',
	support_user_id: '用户ID',
	support_game: '游戏',
	support_platform: '平台',
	support_back: '返回',
	support_mark_solved: '已解决',
	support_official_support: '官方客服',
	support_image: '图片',
	support_reply_hint: '您的补充信息将发送给客服',
	support_send: '发送',
	support_sending: '发送中...',
	support_player: '玩家',
	support_attachment_preview: '附件预览',
	support_remove_attachment: '移除附件',
	support_attachment_fallback: '附件',
	support_survey_title: '问卷调查提示',
	support_survey_message: '您的问题是否已解决？',
	support_survey_close: '关闭',
	support_submit_success: '提交成功',
	support_submit_fail: '提交失败',
	support_close_success: '已关闭聊天',
	support_close_fail: '关闭失败',
	support_rate_title: '请对本次服务做出评价',
	support_input_placeholder: '请输入内容...',
	support_image_pick_error: '未获取到图片路径',
	support_send_fail: '发送失败',
	support_evaluate_success: '评价成功',
	support_evaluate_fail: '评价失败',
	support_status_unreplied: '未回复',
	support_status_replied: '已回复',
	support_status_resolved: '已解决',
	support_status_pending_review: '待评价',
	support_form_type_label: '问题类型',
	support_form_type_placeholder: '请选择问题类型',
	support_form_desc_label: '问题描述',
	support_form_desc_placeholder: '请详细描述您遇到的问题...',
	support_form_upload_label: '上传附件',
	support_form_upload_click: '点击上传文件',
	support_form_upload_tips: '(截屏不超过10MB，视频不超过50MB，不能超过5个)',
	support_form_submit: '确认提交',
	support_form_image_too_big: '图片大小不能超过10MB',
	support_form_video_too_big: '视频大小不能超过50MB',
	cancel_text: '取消',
	// Support types
	support_type_topup: '储值问题',
	support_type_account: '账号问题',
	support_type_guide: '游戏指导',
	support_type_suggestion: '意见建议',
	support_type_event: '活动问题',
	support_type_report: '违规举报',
	support_type_other: '其他问题',
	support_type_topup_hint: '储值未到账、金额异常',
	support_type_account_hint: '登录、封禁、绑定问题',
	support_type_guide_hint: '玩法、任务、进度问题',
	support_type_suggestion_hint: '反馈与建议',
	support_type_report_hint: '作弊、辱骂、违规举报',
	support_type_other_hint: '其他未分类问题',
	support_type_topup_code: '储',
	support_type_account_code: '号',
	support_type_guide_code: '导',
	support_type_suggestion_code: '议',
	support_type_report_code: '举',
	support_type_other_code: '其',
	support_submitting: '提交中...',
	rebate_limited_text: '🔥 限时{pct}%返利',
	rebate_percent_text: '{pct}%返利',
	coupon_booster_label: '返利券',
	coupon_expires_after: '{time}后到期',
	coupon_threshold_shortfall: '还差 {amount} 可用',
	coupon_product_excluded: '当前商品不可使用',
	coupon_channel_restricted: '仅限 {channels} 支付',
	coupon_unavailable_title: '不可用优惠券',
	coupon_skip_text: '暂不使用优惠券',
	coupon_count_unit: '张',
	coupon_picker_title: '选择优惠方式',
	coupon_entry_label: '优惠券',
	coupon_available_count: '{count}张可用',
	coupon_no_use_text: '不使用优惠券',
	coupon_best_tag: '最优',
	coupon_expired_text: '已到期',
	close_text: '关闭',
	discount_coupon_label: '满减券',
	coupon_single_use_hint: '满减券与返利券不可同时使用，每笔订单限选一张',
	order_amount_text: '商品金额',
	discount_amount_text: '优惠抵扣',
	payable_amount_text: '应付金额',
	coupon_extra_rebate_notice: '额外50%返利部分将通过邮件发放，请联系客服登记发放。',
	payment_recommended_text: '推荐支付',
	payment_enjoy_rebate: '享{pct}%返利',
	payment_order_rebate: '本单返利 {amount}',
	payment_order_discount: '本单优惠 {amount}',
	recommend_text: '推荐',
	payment_other_methods_text: '其他支付方式',
	super_coupon_title: '限时神券',
	super_coupon_end_time: '活动结束时间：',
	super_coupon_previous_activity: '上一个神券活动',
	super_coupon_recommended: '超值推荐',
	super_coupon_view_details: '查看神券包详情',
	super_coupon_value_label: '真实折扣价值',
	super_coupon_contents: '神券包内容',
	super_coupon_threshold: '满 {amount}',
	super_coupon_discount: '减 {amount}',
	super_coupon_remaining: '剩余 {time}',
	super_coupon_purchased: '已购买',
	super_coupon_buy_now: '立即购买',
	super_coupon_next_activity: '下一个神券活动',
	super_coupon_switcher: '神券活动切换',
	super_coupon_switch_to: '切换至第 {index} 个神券活动',
	super_coupon_details_title: '神券包详情',
	super_coupon_close_details: '关闭神券包详情',
	super_coupon_empty: '当前没有满减券',
	super_coupon_instructions: '使用说明',
	super_coupon_confirm: '知道了',
	super_coupon_package_name: '神券包',
	super_coupon_get_coupons: '购买立得 {count} 张满减券',
	super_coupon_reward_multiple: '约 {multiple} 倍回馈',
	super_coupon_purchase_limit: '每次限购 {count} 组',
	super_coupon_purchase_interval: '购买间隔 {days} 天',
	super_coupon_rule_separator: '，',
	super_coupon_unknown_status: '状态未知',
	super_coupon_date_format: '{year}年{month}月{day}日 {time}',
	super_coupon_used: '已使用',
	super_coupon_expired: '已过期',
	super_coupon_unit_day: '天',
	super_coupon_unit_days: '天',
	super_coupon_unit_hour: '小时',
	super_coupon_unit_hours: '小时',
	super_coupon_unit_minute: '分钟',
	super_coupon_unit_minutes: '分钟',
	super_coupon_valid_for: '{value} {unit}内有效'
}
